import SimpleBar from "simplebar";

export const generateSimplebars = () => {
    Array.prototype.forEach.call(
        document.querySelectorAll('.blog-content table, .el-scrollable'),
        (el) => new SimpleBar(el, { autoHide: false })
    );
}